<template>
  <div class="filter" v-show="isActive" >
    <div class="inner">
      <div class="mobile-label">
        {{label}}
        <span class="back-button" @click="closePanel"></span>
      </div>
        <div class="autocomplete">
          <input 
            type="text" 
            @input="onChange" 
            v-model="search" 
            @keyup.down="onArrowDown" 
            @keyup.up="onArrowUp" 
            @keyup.enter="onEnter"
            @focus="onFocus"
            :placeholder="placeholder" />



          <ul id="autocomplete-results" v-show="isOpen" class="autocomplete-results">
            <li class="loading" v-if="isLoading">
              Sto caricando...
            </li>

            <li v-if="!isLoading" class="autocomplete-result" @click="setResult('tutti')">
              {{ ViewAllLabel }}
            </li>

            <li 
              v-if="!isLoading "
              v-for="(result, i) in results" 
              :key="i" 
              @click="setResult(result)" 
              class="autocomplete-result" 
              :class="{ 'is-active': result.id === selected.id }">
              {{
                  contentType == 'albums' ?
                      result['title'] + ' - ' + result['artist']['name'] :
                      result['title'] + ' - ' + result['album']['artist']['name'] + ' dall\'album "' + result['album']['title'] + '"'
                }}
              <span></span>
            </li>
            <li class="loading" v-if="!isLoading && results.length == 0">
              Non ci sono risultati per questa ricerca
            </li>
          </ul>
          <div class="filter-btn-wrapper">
            <a class="filter-btn" href="#0" @click.prevent="updateMobile">Filtra</a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios/dist/axios';

export default {

  props: ['viewAllCallback', 'viewAllLabel', 'placeholder', 'isActive', 'selectedData', 'contentType', 'label'],

  created() {
  },

  computed: {

      ViewAllLabel: function() {

          return (this.viewAllLabel) ? this.viewAllLabel : "Vedi tutti"

      }

  },

  data() {
    return {
      isOpen: false,
      results: [],
      selected: {},
      search: "",
      isLoading: false,
      arrowCounter: 0
    };
  },

  methods: {
    onChange() {
      this.isLoading = true;
      this.isOpen = true;
      this.updateResults();
    },

    closePanel() {

        if(this.contentType =='albums') {
            this.$parent.updateAlbumToggle(false)
        } else {
            this.$parent.updateSongToggle(false)
        }

    },

    updateResults() {

        axios.get(window.location.origin + '/api/v1/search/autocomplete/' + this.contentType + '?q=' + this.search)
        .then(resp => {
          // console.log(resp);
          this.results = resp.data[this.contentType];
          this.isLoading = false;
          this.isOpen = true;
        });

    },


    setResult(result) {
      // console.log(result);

      if(result != 'tutti') {
        this.selected = result;
        this.search = result['title'];
      } else {
        this.selected = {
            name  : '',
            q     : this.search
        };
        this.search = '';
      }

      this.isOpen = false;
      
      //if(window.mq.over768) {
        this.$emit('update', this.selected);
      //}
      //console.log(this.selected);
    },

    updateMobile(e) {
      this.$emit('update', this.selected);

      /*const data = {};
      
      if(typeof this.selected.id === 'undefined') {
        data[this.updateKey] = {activeId: -1};
      } else {
        data[this.updateKey] = {activeId: this.selected.id};
      }

      this.$emit('update', data);
      */
    },


    onArrowDown(evt) {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },

    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },

    onEnter() {
      this.search = this.results[this.arrowCounter];
      this.isOpen = false;
      this.arrowCounter = -1;
    },

    onFocus() {
      this.isOpen = true;
    },

    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    }
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },

  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  }
}

</script>

<style lang="scss" scoped>
@import './../css/variables.css';
@import './../css/catalog-filters.css';


.autocomplete {
  position: relative;
  width: 130px;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  background: var(--light-grey);
  height: 120px;
  overflow: auto;
  width: 100%;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.loading {
  background-color: var(--aqua);
  padding: 4px 2px;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: var(--light_purple);
  color: white;
}

.filter-btn-wrapper {
  display: none;
}

li, input {
  font-size: 16px;
  line-height: 19px;
  font-family: arial, sans-serif;
}

input {
  border-radius: 0;
}

@media (min-width: 1024px) {
  .autocomplete-results {
    background: white;
  }

  .autocomplete {
    width: 100%;

    input {
      width: 100%;
      display: block;
      height: 30px;
      border: 1px solid;
      border-top: 0;
      box-sizing: border-box;
      padding: 0 5px;
    }

    ul {
      border: 1px solid;
      border-top: 0;
    }
  }
}


@media (max-width: 1023px) {
  .filter-btn-wrapper {
    display: block;
    text-align: center;
    width: 100%;
    left: 0;
    bottom: calc(20px + 45px);
    position: absolute;
  }

  .autocomplete {
    width: 100%;
    height: 100%;

    input, ul {
      width: 100%;
      display: block;
    }

    ul {
      height: calc(100% - 130px);
      overflow: auto;
    }


    li {
      padding: 5px var(--mobile-padding);
    }

    input {
      padding: 0 10px;
      height: 60px;
      background: white;
      border: 1px solid black;
      box-sizing: border-box;
    }

    .filter-btn {
      display: inline-block;
      background: var(--azure);
      font-weight: 400;
      font-size: 18px;
      padding: 12px 30px;
      width: calc(100% - 40px);
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/vue/components/AutocompleteAsync.vue